export const PNOMAD_BASE_URL = window.ENV ? window.ENV.REACT_APP_BASE_URL : process.env.REACT_APP_BASE_URL ;
export const NGROK_URL = process.env.REACT_APP_NGROK_URL ;
export const apiHeaders = {
  "Accept": 'application/json'
}

export const apiHeadersFormData = {
  "Content-Type": "multipart/form-data",
  "Accept": 'application/json'
}